import react, { useState } from 'react';
import "./ImportItemsPopup.css";
import selectedCheck from "../../webAppAssets/selected-check-icon.svg";
import { Exercise, Folder } from '../TrainingExerciseFolders/TrainingExerciseFolders';
import { useTranslation } from 'react-i18next';
import { AssociateTrainingToSession } from '../CreateSessionPopupItems/CreateSessionPopupItems';


const ImportItemsPopup = (props) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const { t } = useTranslation(["import-exercise-popup"]);

    const handleSelectedItemChange = (item) => {
        setSelectedItem(item);

    }
    return (
        <div className="webapp-import-items-popup">
            <div className="webapp-import-items-popup-inner">
                <AssociateTrainingToSession 
                    trainings={props.trainings} 
                    currentFolder={props.currentFolder} 
                    folders={props.folders} 
                    handleChange={props.handleChange} 
                    handleFolderSelection={props.handleFolderSelection} 
                    session={props.session}
                />
                <div className="webapp-import-items-popup-buttons">
                    <button 
                        className="webapp-import-items-popup-cancel-button" 
                        onClick={props.togglePopup}
                    >
                        {t("Cancel")}
                    </button>
                    <button 
                        className="webapp-import-items-popup-import-button" 
                        onClick={props.handleSave}
                    >
                        {t("Import")}
                    </button>
                </div>
            </div>
        </div>


    )
}


export default ImportItemsPopup;
